import { Platform } from "react-native"

/** Extra scroll padding above the bottom tab bar (incl. Pay button hump) on Payments tabs. */
export function paymentsScreenListBottomPadding(safeAreaBottom: number): number {
  if (Platform.OS === "web") {
    return 24
  }
  return 16 + Math.max(safeAreaBottom + 48, 64)
}
